export default "__VITE_ASSET__BeWMekgq__"